import { useEffect } from "react";

const SITE_URL = "https://cegumasajsalonubursa.com";

export function useSEO({ title, description, keywords, canonical }) {
    useEffect(() => {
        if (title) document.title = title;

        const setMeta = (name, content) => {
            if (!content) return;
            let el =
                document.querySelector(`meta[name="${name}"]`) ||
                document.querySelector(`meta[property="${name}"]`);
            if (!el) {
                el = document.createElement("meta");
                el.setAttribute(name.startsWith("og:") ? "property" : "name", name);
                document.head.appendChild(el);
            }
            el.setAttribute("content", content);
        };

        setMeta("description", description);
        setMeta("keywords", keywords);
        setMeta("og:title", title);
        setMeta("og:description", description);
        setMeta("og:type", "website");
        setMeta("og:locale", "tr_TR");
        setMeta("og:site_name", "Cegu Masaj Salonu Özlüce");

        if (canonical) {
            const absolute = canonical.startsWith("http")
                ? canonical
                : `${SITE_URL}${canonical}`;

            let link = document.querySelector('link[rel="canonical"]');
            if (!link) {
                link = document.createElement("link");
                link.rel = "canonical";
                document.head.appendChild(link);
            }
            link.href = absolute;

            setMeta("og:url", absolute);
        }
    }, [title, description, keywords, canonical]);
}
